import { createTheme } from "@mui/material/styles";

export const dashboardTheme = createTheme({
});